import { Box, Stack, Typography } from '@mui/material';

// Línea de tiempo vertical reutilizada por Formación y Experiencia
export default function Timeline({ items, icon }) {
    return (
        <Stack spacing={0}>
            {items.map((item, i) => (
                <Box key={`${item.title}-${i}`} sx={{ display: 'grid', gridTemplateColumns: '48px 1fr', columnGap: 2 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Box sx={{
                            width: 44, height: 44, borderRadius: '50%', display: 'grid', placeItems: 'center',
                            bgcolor: 'rgba(13,148,136,0.1)', color: 'primary.main', flexShrink: 0,
                        }}>
                            {icon}
                        </Box>
                        {i < items.length - 1 && <Box sx={{ width: 2, flexGrow: 1, bgcolor: 'divider', my: 1 }} />}
                    </Box>
                    <Box sx={{ pb: i < items.length - 1 ? 5 : 0, pt: 0.5 }}>
                        <Typography variant="body2" color="primary" sx={{ fontWeight: 700 }}>{item.period}</Typography>
                        <Typography variant="h6" sx={{ mt: 0.5 }}>{item.title}</Typography>
                        <Typography color="text.secondary" sx={{ fontWeight: 500 }}>{item.subtitle}</Typography>
                        {item.description && (
                            <Typography color="text.secondary" sx={{ mt: 1.5, lineHeight: 1.7 }}>{item.description}</Typography>
                        )}
                        {item.highlights && (
                            <Box component="ul" sx={{ mt: 1.5, mb: 0, pl: 2.5, color: 'text.secondary', '& li': { mb: 0.75, lineHeight: 1.7 } }}>
                                {item.highlights.map((h) => <li key={h}>{h}</li>)}
                            </Box>
                        )}
                    </Box>
                </Box>
            ))}
        </Stack>
    );
}
